"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as c } from "react/jsx-runtime";
import { useTheme as h } from "../../hooks.js";
import { useIsInverseVariant as i } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const l = (_param)=>{
    var { color: t, size: e = 24 } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = i(), m = t !== null && t !== void 0 ? t : n ? o.colors.inverse : o.colors.neutralHigh, { skinName: a } = h();
    return a.match(/^o2-new/i) ? /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ c("path", {
            fill: m,
            d: "M12 2 2.91 7.4V22h18.182V7.4zm7.574 18.443H4.428V8.297L12 3.797l7.573 4.5zM6.318 13.228c0-3.224 2.55-5.849 5.683-5.849q.004.002.005.003 0 .001.005.002h.014c3.123 0 5.663 2.615 5.663 5.829a6 6 0 0 1-.446 2.265c-.853 2.11-2.88 3.598-5.241 3.598-3.132 0-5.683-2.625-5.683-5.848m8.616-.584h1.571a4.67 4.67 0 0 0-2.37-3.543c.45.918.736 2.14.8 3.543m-4.674 1.172c.097 1.847.626 3.16 1.174 3.733v-3.733zm-.005-1.172h1.174V8.87c-.548.58-1.081 1.906-1.174 3.773m-1.134 0c.063-1.408.354-2.64.805-3.558a4.68 4.68 0 0 0-2.39 3.558zm0 1.172H7.54a4.68 4.68 0 0 0 2.385 3.523c-.446-.913-.742-2.13-.805-3.523m3.447-.005v3.783c.567-.544 1.125-1.877 1.227-3.783zm0-1.167h1.227c-.092-1.921-.66-3.269-1.227-3.818zm2.366 1.167c-.063 1.393-.359 2.615-.805 3.523a4.65 4.65 0 0 0 2.07-2.315 4.7 4.7 0 0 0 .311-1.208z"
        })
    })) : /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ c("path", {
            fill: m,
            d: "M12 2 2.91 7.4V22h18.182V7.4zm7.574 18.443H4.428V8.297L12 3.797l7.573 4.5zM6.318 13.228c0-3.224 2.55-5.849 5.683-5.849q.004.002.005.003 0 .001.005.002h.014c3.123 0 5.663 2.615 5.663 5.829a6 6 0 0 1-.446 2.265c-.853 2.11-2.88 3.598-5.241 3.598-3.132 0-5.683-2.625-5.683-5.848m8.616-.584h1.571a4.67 4.67 0 0 0-2.37-3.543c.45.918.736 2.14.8 3.543m-4.674 1.172c.097 1.847.626 3.16 1.174 3.733v-3.733zm-.005-1.172h1.174V8.87c-.548.58-1.081 1.906-1.174 3.773m-1.134 0c.063-1.408.354-2.64.805-3.558a4.68 4.68 0 0 0-2.39 3.558zm0 1.172H7.54a4.68 4.68 0 0 0 2.385 3.523c-.446-.913-.742-2.13-.805-3.523m3.447-.005v3.783c.567-.544 1.125-1.877 1.227-3.783zm0-1.167h1.227c-.092-1.921-.66-3.269-1.227-3.818zm2.366 1.167c-.063 1.393-.359 2.615-.805 3.523a4.65 4.65 0 0 0 2.07-2.315 4.7 4.7 0 0 0 .311-1.208z"
        })
    }));
}, f = l;
export { f as default };
